import { vueApp } from "../Common/vueApp";
import AdminVouchersApp from "./AdminVouchersApp.vue";

export default vueApp(AdminVouchersApp);
